import { FC, useEffect, useState } from "react";
import Icon from "../../../../components/icon";
import CloseIcon from "@ht/shared/fonts/deos-pis/close";
import clsx from "clsx";
import generateUuid from "../../../../utils/generateUuid";
import { ScrollBar } from "@ht/components";
import RobotIcon from "@ht/shared/fonts/deos-pis/robot";
import dayjs from "dayjs";
import { useAppSelector } from "../../../../app/hooks";
import { useHttpRequest } from "../../../../hooks/useHttpRequest";
import SanitizeHTML from "../../../../components/sanitize-html";

const FooterCallControl: FC = () => {
    const { botCallTranscript } = useAppSelector((state) => state.call);
    const [isVisibleBotInteraction, setIsVisibleBotInteraction] = useState(false);
    const [isVisibleBotSummary, setIsVisibleBotSummary] = useState(false);
    const [data, setData] = useState<any[]>([]);
    const [summaryData, setSummaryData] = useState<any>();
    const { incomingMessage } = useAppSelector((state) => state.call);
    const { user } = useAppSelector((state) => state.auth);
    const { sendRequest } = useHttpRequest();
    // useEffect(() => {
    //     if (botCallTranscript.length > 0) {
    //         setData(botCallTranscript);
    //         setIsVisibleBotInteraction(true);
    //     }
    // }, [botCallTranscript])
    const loadBotCallSummary = async () => {
        console.log('loadBotCallSummary()');
        if (user && incomingMessage.call_id) {
            const baseUrl = String(process.env.REACT_APP_CALLNOTIFICATION_SERVICE);
            console.log('loadBotCallSummary() payload', incomingMessage.call_id)
            const result = await sendRequest({
                baseUrl: baseUrl,
                url: `/callnotification/bot-call-summary`,
                method: "get",
                params: {
                    call_id: incomingMessage.call_id
                }
            });

            if (result.data) {
                setSummaryData(result.data);
            }
        }

    }

    const botInteractionHeaderBox = () => {
        return <div className="flex justify-between self-stretch p-2.5 bg-white mb-1 border-b border-gray-200 rounded-t-md ">
            <div className="flex gap-1">
                <button
                    className={clsx(!isVisibleBotSummary ? "border-primary text-gray-700" : "border-gray-200",
                        "flex gap-2 py-1 px-2 justify-center items-center border rounded-md")}
                    onClick={() => setIsVisibleBotSummary(false)}
                >Interaction</button>
                <button
                    className={clsx(isVisibleBotSummary ? "border-primary text-gray-700" : "border-gray-200",
                        "flex gap-2 py-1 px-2 justify-center items-center border rounded-md")}
                    onClick={async () => {
                        setIsVisibleBotSummary(true);
                        await loadBotCallSummary();
                    }}
                >AI Summarization</button>

            </div>
            <CloseIcon className="cursor-pointer" width={12} height={12} onClick={() => setIsVisibleBotInteraction(!isVisibleBotInteraction)} />

        </div >
    }
    const botInteractionMessage = (item: any) => {
        const isBot = item.sender_name == "bot";
        return (
            <div key={generateUuid()} className={clsx("flex flex-col self-stretch gap-1",
                isBot ? "items-end" : "items-start")}>
                {isBot && <div className="flex items-start gap-1 text-primary font-semibold">
                    <RobotIcon width={16} height={16} /> Bot
                </div>}
                <div className={clsx("p-1.5 rounded-md text-gray-900 text-md font-normal max-w-[270px]",
                    isBot ? "bg-primary-100" : "bg-gray-200")}>{item.message}</div>
                <div className="text-base font-semibold text-gray-600">{dayjs(item.created_date).format('HH:mm')}</div>
            </div>
        )
    }
    const summarization = () => {
        return (
            <div className="flex self-stretch items-center">
                {summaryData?.summary ? <SanitizeHTML html={summaryData?.summary ?? ""} /> : "AI is still processing, please retry again..."}
            </div>
        )
    }
    const botInteractionBodyBox = () => {
        return (<ScrollBar
            initialView="top"
            bottom={"10px"}>
            <div className="flex flex-col px-2.5 pb-2.5 self-stretch gap-2.5 h-full">
                {isVisibleBotSummary ? summarization() :
                    data.map(item => botInteractionMessage(item))
                }
            </div>
        </ScrollBar>)
    }
    const botInteractionBox = () => {
        return <div className="flex flex-col border rounded-lg bg-gray-50 border-gray-200 h-[300px]">
            {botInteractionHeaderBox()}
            {botInteractionBodyBox()}
        </div>;
    }

    return <div className="space-y-2 w-full">
        {/* {botCallTranscript.length > 0 && <button
            className="flex gap-2 mt-2 py-1 px-2 justify-center items-center border border-gray-200 rounded-md"
            onClick={() => setIsVisibleBotInteraction(!isVisibleBotInteraction)}
        >
            <div className="text-base text-gray-900">Bot Interaction</div>
            <Icon name="chevron-up" className={!isVisibleBotInteraction ? "rotate-180 ease-in duration-75 transform text-gray-400 h-3 w-3" : "ease-in duration-75 text-gray-400 h-3 w-3"} />
        </button>} */}

        {isVisibleBotInteraction && botInteractionBox()}
    </div>
}

export default FooterCallControl